import ClearIcon from "@mui/icons-material/Clear";
import FeedIcon from "@mui/icons-material/Feed";
import {
  IconButton,
  Typography
} from "@mui/material";
import { StyledFileAttachment } from "../../styled/Dropzone";

const DropzoneFileAttachment = ({
  filename,
  adjuntosConColor,
  quitarArchivo,
}) => {
  return (
    <>
      <StyledFileAttachment.Paper elevation={3} adjuntosConColor={adjuntosConColor}>
        <StyledFileAttachment.Children as={FeedIcon} />
        <StyledFileAttachment.Children as={Typography}
          variant="body2"
          text
        >
          {filename}
        </StyledFileAttachment.Children>
        <StyledFileAttachment.Children as={IconButton} onClick={quitarArchivo}>
          <ClearIcon />
        </StyledFileAttachment.Children>
      </StyledFileAttachment.Paper>
    </>
  );
};

export default DropzoneFileAttachment;
